import * as React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import TinyInput from '@src/components/tiny-input';
import SmsCodeInput from '@src/components/sms-code-input';
import OrderModalStore, { DEVICE_TYPES } from './store';

const styles = require('./index.less');

// 设备配置
const DEVICES = [
  { type: DEVICE_TYPES.ANDROID, label: '安卓' },
  { type: DEVICE_TYPES.IOS, label: '苹果' },
  { type: DEVICE_TYPES.HARMONY, label: '鸿蒙' },
  { type: DEVICE_TYPES.PC, label: '电脑端' }
];

/**
 * 设备选择项
 */
const DeviceItem = observer(({ device, store }) => {
  const isSelected = store.isDeviceSelected(device.type);
  return (
    <div className={cx(styles.deviceItem, isSelected && styles.selected)} onClick={() => store.toggleDevice(device.type)}>
      {/* 左侧勾选框 */}
      <div className={cx(styles.deviceCheckbox, isSelected && styles.checked)}>{isSelected && <div className={styles.checkIcon} />}</div>
      {/* 右侧图标+文字 */}
      <div className={cx(styles.deviceIcon, styles[device.type], isSelected && styles.active)} />
    </div>
  );
});

/**
 * 预约弹窗
 */
const OrderModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.orderModalRoot)}>
        {/* 标题 */}
        <div className={styles.title} />

        {/* 设备选择 */}
        <div className={styles.deviceSection}>
          <div className={styles.deviceGrid}>
            {DEVICES.map(device => {
              return <DeviceItem key={device.type} device={device} store={store} />;
            })}
          </div>
        </div>

        {/* 提示文字 */}
        <div className={styles.tipText} />

        {/* 手机号输入 */}
        <div className={styles.inputSection}>
          <div className={styles.inputWrapper}>
            <TinyInput store={store.phoneInputStore} placeholder="请输入手机号" type="tel" maxLength={11} className={styles.phoneInput} />
          </div>
        </div>

        {/* 验证码输入 */}
        <div className={styles.inputSection}>
          <div className={styles.codeInputWrapper}>
            <TinyInput store={store.codeInputStore} placeholder="请输入验证码" maxLength={6} className={styles.codeInput} />
            <SmsCodeInput
              codeBtnClassName={styles.codeBtn}
              btnDisableClassName={styles.btnDisable}
              phone={store.phoneInputStore.value}
              sendCode={store.onSendVCRequest}
            />
          </div>
        </div>

        {/* 协议勾选 */}
        <div className={styles.agreementSection}>
          <div className={cx(styles.checkbox, store.isAgreementChecked && styles.checked)} onClick={store.toggleAgreement} />
          <div className={styles.agreementText}>
            <span onClick={store.toggleAgreement}>已阅读并同意</span>
            <Link className={styles.agreement_link} href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazprh7aww1" target="_blank">
              《金山网络服务使用协议》
            </Link>
            <br />
            <Link className={styles.agreement_link} href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazvjmyopa9" target="_blank">
              《金山在线隐私权政策》
            </Link>
            {/* onClick={store.toggleAgreement} */}
          </div>
        </div>

        {/* 提交按钮 */}
        <Link className={styles.submitBtn} onClick={store.onSubmit} />

        {/* 关闭按钮 */}
        <Link className={styles.closeBtn} onClick={store.onClickClose} />

        {/* 去微信弹窗预约 */}
        <Link className={styles.toWechatBtn} onClick={store.openOrderTipsModalStore} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(OrderModal, OrderModalStore);
